export default "__VITE_ASSET__BaEdbytB__"